import type { MarkerColor } from '@rio-cloud/rio-uikit/mapTypes';
import SingleMapMarker from '@rio-cloud/rio-uikit/SingleMapMarker';
import type { IntlShape } from 'react-intl';

import type { TourStopMapRole } from './tourStopsMap.utils.ts';

export type TourStopSequence = {
    role: TourStopMapRole;
    sequence: number;
};

type TourStopSequenceMarkerProps = TourStopSequence & {
    ariaLabel: string;
};

const markerColors: Record<TourStopMapRole, MarkerColor> = {
    start: 'bg-map-marker-success',
    intermediate: 'bg-map-marker-route',
    destination: 'bg-map-marker-danger',
    'start-destination': 'bg-map-marker-warning',
};

export const formatTourStopMarkerLabel = (intl: IntlShape, { sequence, role }: TourStopSequence) =>
    intl.formatMessage(
        {
            id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.route-preview.marker',
            defaultMessage: 'Stop {sequence}, {role}',
        },
        {
            sequence,
            role: intl.formatMessage({
                id: `intl-msg:ordercom-cloud-frontend.tours.create-dialog.route-preview.role.${role}`,
            }),
        }
    );

export const TourStopSequenceMarker = ({ ariaLabel, role, sequence }: TourStopSequenceMarkerProps) => (
    <SingleMapMarker
        aria-label={ariaLabel}
        role='img'
        name={sequence}
        markerColor={markerColors[role]}
        anchorSize='lg'
        clickable={false}
    />
);

export const TourStopSequenceBadge = ({ ariaLabel, role, sequence }: TourStopSequenceMarkerProps) => (
    <span
        aria-label={ariaLabel}
        role='img'
        className={`${markerColors[role]} rounded-circle display-grid place-items-center text-color-white text-bold width-30 height-30 flex-0`}
    >
        {sequence}
    </span>
);
